<template>
    <div id="product-order-details-view" class="vx-row" >
        <div class="vx-col w-full">
            <vx-card :title="orderDetails.product_order_code">
            <!-- <vx-card>   -->
                <template slot="actions">
                    <div class="flex">
                        <div class="flex">
                        <vs-button @click.stop="onClickProductOrderUpdate(orderDetails.id, orderDetails.customer.id)" color="warning" type="border" >Update Order</vs-button>
                        <vs-button @click="onClickBack" class="ml-2" color="primary" type="filled">Back to orders</vs-button>
                        </div>
                    </div>
                </template>

                <div class="vx-row md:mb-3 mt-8">
                    <div class="vx-col md:w-1/3 w-full">
                        <vs-row vs-type="flex">
                        <vs-col
                            vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                            <feather-icon icon="UserCheckIcon" class="text-success cursor-pointer"/>
                        </vs-col>
                        <vs-col
                            vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                            <span class="text-md break-all">
                                <h5 class="mb-2">Order By</h5>
                                {{orderDetails.created_by}}
                            </span>
                        </vs-col>
                        </vs-row>
                    </div>

                    <div class="vx-col md:w-1/3 w-full">
                        <vs-row vs-type="flex">
                        <vs-col
                            vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                            <feather-icon icon="CalendarIcon" class="text-success cursor-pointer"/>
                        </vs-col>
                        <vs-col
                            vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                            <span class="text-md break-all">
                                <h5 class="mb-2">Order Date</h5>
                                {{__dateTimeFormatter(orderDetails.created_at)}}
                            </span>
                        </vs-col>
                        </vs-row>
                    </div>
                    <div class="vx-col md:w-1/3 w-full">
                        <vs-row vs-type="flex">
                        <vs-col
                            vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                            <feather-icon icon="TruckIcon" class="text-success cursor-pointer"/>
                        </vs-col>
                        <vs-col
                            vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                            <span class="text-md break-all">
                                <h5 class="mb-2">Delivery Instructions</h5>
                                {{orderDetails.delivery_instruction || 'N/A'}}
                            </span>
                        </vs-col>
                        </vs-row>
                    </div>
                </div>

                <div class="vx-row md:mb-3 mt-16">
                    <div class="vx-col md:w-1/3 w-full">
                        <vs-row vs-type="flex">
                        <vs-col
                            vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                            <feather-icon icon="MapPinIcon" class="text-success cursor-pointer"/>
                        </vs-col>
                        <vs-col
                            vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                            <span class="text-md">
                                <h5 class="mb-2">Address</h5>
                                {{ orderDetails.name }}  <br v-if="orderDetails.name">
                                {{orderDetails.line1}} <br v-if="orderDetails.line1">
                                {{orderDetails.line2}} <br v-if="orderDetails.line2">
                                {{orderDetails.line3}} <br v-if="orderDetails.line3">
                                {{orderDetails.town_state}} <br>
                                {{orderDetails.post_code}} <br>
                                {{orderDetails.country}} <br>
                            </span>
                        </vs-col>
                        </vs-row>
                    </div>
                </div>
                
            </vx-card>

            <vx-card class="mt-8" title="Finished products">
                <div class="vx-row">
                <div class="vx-col w-full md:mb-0">
                    <product-order-table
                        v-on:refresh="refreshData"
                        v-bind:id="orderDetails.id"
                        v-bind:status_id="orderDetails.status.id"
                        v-bind:items="orderDetails.formulation_items"
                        v-bind:is_item_status_handled_individually="orderDetails.is_item_status_handled_individually"
                    />
                </div>
                </div>
            </vx-card>
        </div>
        <update-customer-product-order-pop-up ref="updateCustomerProductOrderPopUp"/>
    </div>
</template>

<script>
    import { RepositoryFactory } from '@/repository/RepositoryFactory'
    const CustomerRepository = RepositoryFactory.get('customer')
    import SuccessMessage from '@/mixins/SuccessMessage'
    import ErrorMessages from '@/mixins/ErrorMessages'
    import ProductOrderTable from './ProductOrderTable'
    import UpdateCustomerProductOrderPopUp from '@/components/popups/customer/product-orders/UpdateCustomerProductOrderPopUp'
    import {product_order_statuses} from '@/constants/statuses'

  export default {
    name: "ProductOrderDetailsView",
    components: {
        ProductOrderTable,
        UpdateCustomerProductOrderPopUp,
    },
    data: function() {
      return {
        orderDetails: {},
        id: '',
        dataLoaded: false,
        account_currency: 'GBP',
        product_order_statuses: product_order_statuses
      }
    },
    mixins : [ SuccessMessage, ErrorMessages],
    async mounted() {
      this.id = this.$route.params.id
      await this.getProductOrderDetails()
    },
    methods: {
        onClickBack() {
        this.$router.push({path: `/pages/customer-product-orders`})
        },
        async refreshData () {
        this.getProductOrderDetailsView()
        },


    async getProductOrderDetails() {
        this.$vs.loading()
        const {data} = await CustomerRepository.getCustomerProductOrder(this.id)
        this.orderDetails = data.data
        this.$vs.loading.close()
    },

    async getProductOrderDetailsView() {
        await this.getProductOrderDetails()
    },

    async onClickProductOrderUpdate (id) {
        await this.$refs.updateCustomerProductOrderPopUp.openPopup(id)
    },

    productOrderStatusColorFactory() {
          const status = this.product_order_statuses.find((n) => n.name === this.orderDetails.status.name)
          return status ? status.color : 'dark'
      },
      async onChangeOrderStatusHandle () {
        await this.$vs.loading({
          container: '#product-order-details-view',
          scale: 0.45
        })
        try {
          await CustomerRepository.changeRmOrderHandleType(this.id)
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#product-order-details-view > .con-vs-loading')
      },
      async onClickStatusChangeConfirm(id, status) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.onChangeProductOrderStatus,
          parameters: [id, status]
        })
      },
      async onChangeProductOrderStatus(params){
        await this.$vs.loading({
          container: '#product-order-details-view',
          scale: 0.45
        })
        try {
          await CustomerRepository.statusChangeCustomerProductOrders(params[0], params[1])
          this.showSuccessMessage('Status change successfully!')
          await this.getProductOrderDetails()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#product-order-details-view > .con-vs-loading')
      },

    }
  }
</script>
<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
  table td {
    vertical-align: top;
    min-width: 140px;
    padding-bottom: .8rem;
    word-break: break-all;
    }

</style>



